module.exports = __webpack_public_path__ + "static/media/left-arrow.c207f596.svg";